import { render, staticRenderFns } from "./addCreative.vue?vue&type=template&id=1c10fe8a&"
import script from "./addCreative.vue?vue&type=script&lang=js&"
export * from "./addCreative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports